import {
  NgModule,
  Inject,
  Type
} from '@angular/core';
import { ComponentRegistryService } from './component-registry.service';
import { ROOT_COMPONENTS } from './tokens';

@NgModule()
export class ComponentRootModule {

  constructor(
    private register: ComponentRegistryService,
    @Inject(ROOT_COMPONENTS) rootComponents: Array<Type<any>>
  ) {
    rootComponents.forEach(rc => this.add(rc));
  }

  public add(component: Type<any>) {
    this.register.add(component);
  }

}
